import React from "react";

const getInitials = (name) =>
  (name || "")
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

const CommentAvatar = ({ avatar, name, size = "md" }) => (
  <div className={`comment-avatar comment-avatar--${size}`}>
    {avatar ? (
      <img src={avatar} alt="" />
    ) : (
      <span className="comment-avatar__initials">{getInitials(name) || "?"}</span>
    )}
  </div>
);

export default CommentAvatar;
